"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getAnchor = getAnchor;
exports.isHorizontal = isHorizontal;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _Backdrop = _interopRequireDefault(require("../Backdrop"));
var _Box = _interopRequireDefault(require("../Box"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _Slide = _interopRequireDefault(require("../Slide"));
var _transitions = require("../styles/transitions");
var _tss = require("../styles/tss");
var _useTheme = require("../styles/useTheme");
var _capitalizeFirstWord = require("../utilities/capitalizeFirstWord");
const _excluded = ["BackdropProps"],
  _excluded2 = ["anchor", "BackdropProps", "children", "classes", "className", "fillViewport", "ModalProps", "onClose", "open", "BoxProps", "SlideProps", "transitionDuration", "variant"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const cssVars = {
  maxHeight: '--boxMaxHeight'
};
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsDrawer',
  uniqId: 'qsO0Fk'
})((theme, _params, classes) => {
  const boxSizesValues = {
    maxHeightFull: '100%',
    xs: {
      maxHeightAnchorY: '75dvh'
    },
    sm: {
      maxHeightAnchorY: '50dvh'
    }
  };
  const boxMargin = theme.busbud.spacing(1);
  return {
    /* Styles applied to the root element. */
    root: {},
    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {},
    /* Styles applied to the Box component. */
    box: {
      [cssVars.maxHeight]: boxSizesValues.maxHeightFull,
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      flex: '1 0 auto',
      maxWidth: `calc(100% - ${boxMargin} * 2)`,
      maxHeight: `calc(var(${cssVars.maxHeight})} - ${boxMargin} * 2)`,
      margin: boxMargin,
      borderRadius: theme.busbud.styles.rounding.xl,
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      inset: 0,
      backgroundColor: theme.busbud.colors.background.primary.opaque,
      boxShadow: theme.busbud.styles.shadow.subtle.lg,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 0,
      // We don't need this breakpoint, but we use it because without it, JSS reorders the styles
      // and puts this block after the next breakpoint, which affects the cascade.
      // Details: https://github.com/busbud/design-system/pull/993#discussion_r1160028467
      [theme.busbud.breakpoints.up('xs')]: {
        [`&:not(.${classes.fillViewport})`]: {
          // For the vertical drawers, we override a `maxHeight` variable
          // that will calculate the maximum height for the `box` element.
          [`&.${classes.boxAnchorTop}, &.${classes.boxAnchorBottom}`]: {
            [cssVars.maxHeight]: boxSizesValues.xs.maxHeightAnchorY
          },
          // Depending on the direction, we disable stretching of the `box` element
          // in the opposite side.
          [`&.${classes.boxAnchorTop}`]: {
            bottom: 'auto'
          },
          [`&.${classes.boxAnchorBottom}`]: {
            top: 'auto'
          },
          [`&.${classes.boxAnchorLeft}`]: {
            right: 'auto'
          },
          [`&.${classes.boxAnchorRight}`]: {
            left: 'auto'
          }
        }
      },
      [theme.busbud.breakpoints.up('sm')]: {
        [`&:not(.${classes.fillViewport})`]: {
          // For the vertical drawers, we override a `maxHeight` variable
          // that will calculate the maximum height for the `box` element.
          [`&.${classes.boxAnchorTop}, &.${classes.boxAnchorBottom}`]: {
            [cssVars.maxHeight]: boxSizesValues.sm.maxHeightAnchorY
          }
        }
      }
    },
    /* Styles applied to the box component if `anchor="left"`. */
    boxAnchorLeft: {},
    /* Styles applied to the box component if `anchor="right"`. */
    boxAnchorRight: {},
    /* Styles applied to the box component if `anchor="top"`. */
    boxAnchorTop: {},
    /* Styles applied to the box component if `anchor="bottom"`. */
    boxAnchorBottom: {},
    /* Styles applied to the box component if `anchor="left"` and `variant` is not "temporary". */
    boxAnchorDockedLeft: {},
    /* Styles applied to the box component if `anchor="top"` and `variant` is not "temporary". */
    boxAnchorDockedTop: {},
    /* Styles applied to the box component if `anchor="right"` and `variant` is not "temporary". */
    boxAnchorDockedRight: {},
    /* Styles applied to the box component if `anchor="bottom"` and `variant` is not "temporary". */
    boxAnchorDockedBottom: {},
    /* Styles applied to the box component if `fillViewport={true}`. */
    fillViewport: {},
    /* Styles applied to the Modal component. */
    modal: {}
  };
});
const oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
const oppositeAnchor = {
  left: 'right',
  right: 'left',
  top: 'bottom',
  bottom: 'top'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeAnchor[anchor] : anchor;
}
const defaultTransitionDuration = {
  enter: _transitions.duration.enteringScreen,
  exit: _transitions.duration.leavingScreen
};
const getAnchorClassKey = anchor => `boxAnchor${(0, _capitalizeFirstWord.capitalizeFirstWord)(anchor)}`;
const getDockedAnchorClassKey = anchor => `boxAnchorDocked${(0, _capitalizeFirstWord.capitalizeFirstWord)(anchor)}`;

/**
 * Navigation drawers provide access to destinations in your app. Side sheets are surfaces containing supplementary content that are anchored to the left or right edge of the screen.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-navigation-drawer--page)
 */
const Drawer = /*#__PURE__*/React.forwardRef(function Drawer(props, ref) {
  const {
      anchor: anchorProp = 'left',
      BackdropProps,
      children,
      classes: classesOverrides,
      className,
      fillViewport,
      ModalProps: {
        BackdropProps: BackdropPropsProp
      } = {},
      onClose,
      open = false,
      BoxProps = {},
      SlideProps,
      transitionDuration = defaultTransitionDuration,
      variant = 'temporary'
    } = props,
    ModalProps = (0, _objectWithoutProperties2.default)(props.ModalProps, _excluded),
    other = (0, _objectWithoutProperties2.default)(props, _excluded2);
  const {
    cx,
    classes
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  const theme = (0, _useTheme.useTheme)();

  // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.
  const mounted = React.useRef(false);
  React.useEffect(() => {
    mounted.current = true;
  }, []);
  const anchor = getAnchor(theme, anchorProp);
  const drawer = /*#__PURE__*/React.createElement(_Box.default, (0, _extends2.default)({}, BoxProps, {
    className: cx(classes.box, classes[getAnchorClassKey(anchor)], {
      [classes.fillViewport]: fillViewport,
      [classes[getDockedAnchorClassKey(anchor)]]: variant !== 'temporary'
    }, BoxProps.className)
  }), children);
  if (variant === 'permanent') {
    return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
      className: cx(classes.root, classes.docked, className),
      ref: ref
    }, other), drawer);
  }
  const slidingDrawer = /*#__PURE__*/React.createElement(_Slide.default, (0, _extends2.default)({
    in: open,
    direction: oppositeDirection[anchor],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps), drawer);
  if (variant === 'persistent') {
    return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
      className: cx(classes.root, classes.docked, className),
      ref: ref
    }, other), slidingDrawer);
  }

  // variant === temporary
  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
    BackdropProps: _objectSpread(_objectSpread(_objectSpread({}, BackdropProps), BackdropPropsProp), {}, {
      transitionDuration
    }),
    BackdropComponent: _Backdrop.default,
    className: cx(classes.root, classes.modal, className),
    open: open,
    onClose: onClose,
    ref: ref
  }, other, ModalProps), slidingDrawer);
});
var _default = exports.default = Drawer;